/**
 * Sizing Guide - Unit Toggle Functionality
 * Handles switching between centimeters and inches
 */

const SizingGuide = () => {
	const selectors = {
		section: '.sizing-guide',
		unitToggle: '.js-unit-toggle',
		unitCm: '.unit-cm',
		unitIn: '.unit-in',
		activeClass: 'sizing-guide__unit-btn--active'
	};

	let section;
	let toggleButtons;
	let currentUnit = 'cm';

	function init() {
		section = document.querySelector(selectors.section);
		
		if (!section) {
			return;
		}

		toggleButtons = section.querySelectorAll(selectors.unitToggle);
		
		if (!toggleButtons.length) {
			return;
		}

		setEventListeners();
		updateDisplay();
	}

	function setEventListeners() {
		toggleButtons.forEach(button => {
			button.addEventListener('click', handleToggleClick);
		});
	}

	function handleToggleClick(event) {
		const button = event.currentTarget;
		const unit = button.getAttribute('data-unit');
		
		if (unit === currentUnit) {
			return;
		}

		currentUnit = unit;
		updateActiveButton();
		updateDisplay();
	}

	function updateActiveButton() {
		toggleButtons.forEach(button => {
			const buttonUnit = button.getAttribute('data-unit');
			
			if (buttonUnit === currentUnit) {
				button.classList.add(selectors.activeClass);
			} else {
				button.classList.remove(selectors.activeClass);
			}
		});
	}

	function updateDisplay() {
		const cmElements = section.querySelectorAll(selectors.unitCm);
		const inElements = section.querySelectorAll(selectors.unitIn);

		if (currentUnit === 'cm') {
			cmElements.forEach(el => el.style.display = '');
			inElements.forEach(el => el.style.display = 'none');
		} else {
			cmElements.forEach(el => el.style.display = 'none');
			inElements.forEach(el => el.style.display = '');
		}
	}

	return Object.freeze({
		init
	});
};

// Initialize when DOM is ready
const initSizingGuide = () => {
	const sizingGuide = SizingGuide();
	sizingGuide.init();

	// Also register with theme core if available
	if (window.themeCore && window.themeCore.utils && window.themeCore.utils.register) {
		window.themeCore.SizingGuide = sizingGuide;
		window.themeCore.utils.register(sizingGuide, 'sizing-guide');
	}
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initSizingGuide);
} else {
	initSizingGuide();
}

